var _path, _path2, _path3, _path4, _g, _path5, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_149667",
    "data-name": "Group 149667",
    xmlns: "http://www.w3.org/2000/svg",
    width: 81.157,
    height: 81.157,
    viewBox: "0 0 81.157 81.157",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_102382",
    "data-name": "Path 102382",
    d: "M44.383,0H8.718A8.728,8.728,0,0,0,0,8.718V72.439a8.728,8.728,0,0,0,8.718,8.718H53.1a8.728,8.728,0,0,0,8.718-8.718v-55Z",
    fill: "#e7edfb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_102383",
    "data-name": "Path 102383",
    d: "M208.473,0H195V81.157h22.191a8.728,8.728,0,0,0,8.718-8.718v-55Z",
    transform: "translate(-164.091)",
    fill: "#dce3f1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_102384",
    "data-name": "Path 102384",
    d: "M280,0V15.058a2.378,2.378,0,0,0,2.378,2.378h15.058Z",
    transform: "translate(-235.617)",
    fill: "#8098cb"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_102385",
    "data-name": "Path 102385",
    d: "M89.324,164.755H62.378a2.378,2.378,0,1,1,0-4.755H89.324a2.378,2.378,0,1,1,0,4.755Zm-6.34,9.511H62.378a2.378,2.378,0,0,1,0-4.755H82.984a2.378,2.378,0,0,1,0,4.755Zm0,9.511H62.378a2.378,2.378,0,0,1,0-4.755H82.984a2.378,2.378,0,0,1,0,4.755Zm0,9.511H62.378a2.378,2.378,0,0,1,0-4.755H82.984a2.378,2.378,0,0,1,0,4.755Z",
    transform: "translate(-50.489 -134.638)",
    fill: "#7aa4ff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_149666",
    "data-name": "Group 149666",
    transform: "translate(30.909 25.362)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102386",
    "data-name": "Path 102386",
    d: "M202.926,160H195v4.755h7.926a2.378,2.378,0,0,0,0-4.755Zm-6.34,14.266a2.378,2.378,0,0,0,0-4.755H195v4.755Zm0,9.511a2.378,2.378,0,0,0,0-4.755H195v4.755Zm0,9.511a2.378,2.378,0,0,0,0-4.755H195v4.755Z",
    transform: "translate(-195 -160)",
    fill: "#7aa4ff"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_102387",
    "data-name": "Path 102387",
    d: "M285.371,218.5l-11.894-11.894a16.659,16.659,0,1,0-3.362,3.362l11.894,11.894a2.378,2.378,0,0,0,3.362-3.362Z",
    transform: "translate(-204.91 -151.468)",
    fill: "#bcbcbc"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9652",
    "data-name": "Ellipse 9652",
    cx: 11.888,
    cy: 11.888,
    r: 11.888,
    transform: "translate(43.354 33.287)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectAddress);
export default __webpack_public_path__ + "static/media/selectAddress.e38c6bb79764e0adf1cb199842ba6623.svg";
export { ForwardRef as ReactComponent };